export default function(name, value, days = 0, session = false) {
  let date = new Date();

  if (!days) {
    date.setTime(date.getTime() - 86400000);
  }
  else {
    date.setTime(date.getTime() + (days * 86400000));
  }

  let expires = `expires=${date.toGMTString()}`;

  if (session) {
    expires = '';
  }

  document.cookie = `${name}=${value}; ${expires}; path=/`;
}
